// extracted by mini-css-extract-plugin
export default {"activatePlanContainer":"ZUqd8jivtXIRMjWlYjk--A==","labelWrapper":"L7f88bLksbLa55dqeH-Kmg==","activateLabel":"NF7MC8fMr6mYPFFgDASB+A=="};